const TOKEN = "token" as const;
const USERNAME_PASSWORD = "username_password" as const;
const OTHER = "other" as const;

const DistributorAuthMethods = {
  Token: TOKEN,
  UsernamePassword: USERNAME_PASSWORD,
  Other: OTHER,
} as const;

export type DistributorAuthMethod =
  (typeof DistributorAuthMethods)[keyof typeof DistributorAuthMethods];

export default DistributorAuthMethods;
